module.exports = __webpack_public_path__ + "img/blog-1.248823c5.webp";